import { Feature } from '../../components/feature';
import Button from '../../components/Button';

export default function Teacher() {
  return  <Feature
        badge={"AI Powered Teaching for Indian Schools"}
        title={"Real Education Shapes Not Just Brilliant Students — But Balanced Human Beings"}
        description={
          <>
            <p>
              Your teachers build knowledge. Our AI Teachers strengthen the mindset behind it — so children learn with calm, focus, and confidence.
            </p>
          </>
        }
        imageAlt="digital markting"
        imageQuery="images/new-landing-page/teachersv2.png"
        cta={
          <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
              <Button label='Book Live Demo' type='gradient' />
              <Button label="Claim ₹5 Lakh Free Access" type='outlined' />
            </div>
        }
      />
}